(function () {
  function initPortfolioModal(section) {
    if (!section || section.dataset.portfolioModalReady === 'true') return;

    section.dataset.portfolioModalReady = 'true';

    var modal = section.querySelector('.portfolio-modal');
    var cards = section.querySelectorAll('.portfolio-card');
    var closeButtons = section.querySelectorAll('[data-close-modal]');

    var modalImage = section.querySelector('.portfolio-modal__image');
    var modalTitle = section.querySelector('.portfolio-modal__title');
    var modalSummary = section.querySelector('.portfolio-modal__summary');
    var metaWrap = section.querySelector('.portfolio-modal__meta');
    var impactWrap = section.querySelector('.portfolio-modal__impact');
    var beyondWrap = section.querySelector('.portfolio-modal__beyond');
    var dueWrap = section.querySelector('.portfolio-modal__due');
    var riskWrap = section.querySelector('.portfolio-modal__risk');
    var labelsWrap = section.querySelector('.portfolio-modal__labels');
    var sdgsWrap = section.querySelector('.portfolio-modal__sdgs');
    var issuancesWrap = section.querySelector('.portfolio-modal__issuances');

    var sectionImpact = section.querySelector('.portfolio-modal__section--impact');
    var sectionBeyond = section.querySelector('.portfolio-modal__section--beyond');
    var sectionDue = section.querySelector('.portfolio-modal__section--due');
    var sectionRisk = section.querySelector('.portfolio-modal__section--risk');
    var sectionLabels = section.querySelector('.portfolio-modal__section--labels');
    var sectionSdgs = section.querySelector('.portfolio-modal__section--sdgs');
    var sectionIssuances = section.querySelector('.portfolio-modal__section--issuances');

    var loadingState = section.querySelector('.portfolio-modal__state--loading');
    var errorState = section.querySelector('.portfolio-modal__state--error');

    var apiToken = section.dataset.apiToken || '';

    function openModal() {
      if (!modal) return;

      modal.hidden = false;
      document.body.classList.add('portfolio-modal-open');
    }

    function closeModal() {
      if (!modal) return;

      modal.hidden = true;
      document.body.classList.remove('portfolio-modal-open');
    }

    function resetSections() {
      metaWrap.innerHTML = '';
      impactWrap.innerHTML = '';
      beyondWrap.innerHTML = '';
      dueWrap.innerHTML = '';
      riskWrap.innerHTML = '';
      labelsWrap.innerHTML = '';
      sdgsWrap.innerHTML = '';
      issuancesWrap.innerHTML = '';

      sectionImpact.hidden = true;
      sectionBeyond.hidden = true;
      sectionDue.hidden = true;
      sectionRisk.hidden = true;
      sectionLabels.hidden = true;
      sectionSdgs.hidden = true;
      sectionIssuances.hidden = true;

      errorState.hidden = true;
      loadingState.hidden = true;
    }

    function setImage(src, alt) {
      if (src) {
        modalImage.src = src;
        modalImage.alt = alt || '';
        modalImage.hidden = false;
      } else {
        modalImage.src = '';
        modalImage.alt = '';
        modalImage.hidden = true;
      }
    }

    function addMetaItem(label, value) {
      if (!value) return;

      var item = document.createElement('div');
      item.className = 'portfolio-modal__meta-item';

      var strong = document.createElement('strong');
      strong.textContent = label;

      var span = document.createElement('span');
      span.textContent = value;

      item.appendChild(strong);
      item.appendChild(span);
      metaWrap.appendChild(item);
    }

    function renderTags(container, items, prefix) {
      if (!Array.isArray(items) || !items.length) return false;

      items.forEach(function (item) {
        var tag = document.createElement('span');
        tag.className = 'portfolio-modal__tag';
        tag.textContent = prefix ? prefix + item : item;
        container.appendChild(tag);
      });

      return true;
    }

    function renderIssuances(items) {
      if (!Array.isArray(items) || !items.length) return false;

      items.forEach(function (item) {
        var row = document.createElement('div');
        row.className = 'portfolio-modal__issuance';

        var year = item && item.vintage_year ? item.vintage_year : 'N/A';
        var amount = item && typeof item.total_amount !== 'undefined'
          ? Number(item.total_amount).toLocaleString()
          : 'N/A';

        var yearSpan = document.createElement('span');
        yearSpan.textContent = 'Vintage year: ' + year;

        var amountSpan = document.createElement('span');
        amountSpan.textContent = 'Total amount: ' + amount;

        row.appendChild(yearSpan);
        row.appendChild(amountSpan);
        issuancesWrap.appendChild(row);
      });

      return true;
    }

    function formatLifetime(lifetime) {
      if (!lifetime) return '';

      if (typeof lifetime === 'string') return lifetime;

      if (typeof lifetime === 'object') {
        var parts = [];

        if (lifetime.start_year) parts.push('Start: ' + lifetime.start_year);
        if (lifetime.end_year) parts.push('End: ' + lifetime.end_year);
        if (lifetime.years) parts.push('Years: ' + lifetime.years);
        if (lifetime.description) parts.push(lifetime.description);

        return parts.join(' | ');
      }

      return '';
    }

    function renderProjectData(data, fallback) {
      var title = data.name || data.title || fallback.title || '';
      var summary =
        data.description ||
        data.summary ||
        data.short_description ||
        fallback.summary ||
        '';

      modalTitle.textContent = title;
      modalSummary.textContent = summary;

      setImage(data.primary_image_url || fallback.image || '', title);

      addMetaItem('Impact type', data.impact_type);
      addMetaItem('Methodology', data.methodology);
      addMetaItem('Verifier', data.verifier);
      addMetaItem('Permanence', data.permanence);
      addMetaItem('Lifetime', formatLifetime(data.lifetime));
      addMetaItem('Longitude', data.location_longitude);

      if (data.beyond_carbon) {
        beyondWrap.textContent = data.beyond_carbon;
        sectionBeyond.hidden = false;
      }

      if (data.due_diligence) {
        dueWrap.textContent = data.due_diligence;
        sectionDue.hidden = false;
      }

      if (data.risk_of_reversal) {
        riskWrap.textContent = data.risk_of_reversal;
        sectionRisk.hidden = false;
      }

      if (data.impact_type || data.methodology || data.verifier || data.permanence || data.lifetime || data.location_longitude) {
        sectionImpact.hidden = false;
        impactWrap.textContent = 'This project contributes through ' + (data.impact_type || 'verified climate action') + '.';
      }

      if (renderTags(labelsWrap, data.third_party_labels || [])) {
        sectionLabels.hidden = false;
      }

      if (renderTags(sdgsWrap, data.un_sdg_goals || [], 'Goal ')) {
        sectionSdgs.hidden = false;
      }

      if (renderIssuances(data.credit_issuances || [])) {
        sectionIssuances.hidden = false;
      }
    }

    function showFallback(card) {
      var fallback = {
        title: card.getAttribute('data-title') || '',
        summary: card.getAttribute('data-summary') || '',
        image: card.getAttribute('data-image') || ''
      };

      modalTitle.textContent = fallback.title;
      modalSummary.textContent = fallback.summary;
      setImage(fallback.image, fallback.title);

      return fallback;
    }

    function fetchProject(projectId, fallback) {
      if (!projectId || !apiToken) {
        errorState.hidden = false;
        loadingState.hidden = true;
        return;
      }

      loadingState.hidden = false;
      errorState.hidden = true;

      fetch('https://api.cnaught.com/v1/projects/' + encodeURIComponent(projectId), {
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + apiToken
        }
      })
        .then(function (res) {
          if (!res.ok) {
            throw new Error('API request failed');
          }

          return res.json();
        })
        .then(function (data) {
          loadingState.hidden = true;
          renderProjectData(data, fallback);
        })
        .catch(function (error) {
          console.error(error);
          loadingState.hidden = true;
          errorState.hidden = false;
        });
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        resetSections();
        openModal();

        var fallback = showFallback(card);
        var projectId = card.getAttribute('data-project-id');

        fetchProject(projectId, fallback);
      });
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal && !modal.hidden) {
        closeModal();
      }
    });
  }

  function initAllPortfolioModals(scope) {
    var root = scope || document;
    var sections = root.querySelectorAll('[data-portfolio-modal-section]');

    sections.forEach(function (section) {
      initPortfolioModal(section);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAllPortfolioModals(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAllPortfolioModals(event.target);
  });
})();